import { useEffect, useRef } from 'react';

/** Runs a callback exactly once when its condition becomes true, then never again.
 * Unlike `useEffect()` we do not take a dependency array, because the function never needs
 * re-running so we do not need to observe changes.
 */
export const useEffectOnceOnCondition = (condition: boolean, callback: () => void) => {
  /** Store the  last-passed callback on a ref so that it is not a dependency for the effect */
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (condition && !hasRunRef.current) {
      hasRunRef.current = true;
      callbackRef.current();
    }
  }, [condition]);
};

/** Runs a callback exactly once when the component mounts, then never again. */
export const useEffectOnceOnMount = (callback: () => void) =>
  useEffectOnceOnCondition(true, callback);
